module.exports = __webpack_public_path__ + "media/images/bottles-outline-b92a02074c77a733aa69bfb0ea7c7d85.svg";